import {acceptance} from '../../environment.acc';
import {development} from '../../environment.dev';
import {production} from '../../environment.prd';
import {Env} from '../../utils/wu-constant';

export const getConfig = () => {
  if (process.env.NODE_ENV === Env.dev) {
    return development;
  } else if (process.env.NODE_ENV === Env.acc) {
    return acceptance;
  } else {
    return production;
  }
};
